
import {defineComponent} from 'vue'
import {LichenRecordField, newSpecimen} from "@/config/config-lichen"
import SpecimenPickerItem from "@/components/picker/SpecimenPickerItem.vue";
import Button from "primevue/button";

export default defineComponent({
  name: "SpecimenPicker",
  components: { SpecimenPickerItem, Button },
  data () {
      return {
        specimens: [] as any[],
        added: false as Boolean
      }
    },
  props: {
    name: { type: String, required: true },
    value: { type: Array, required: true }
  },
  methods: {
    remove(idx: number) {
      this.specimens.splice(idx, 1)
    },
    add() {
      this.added = true
      this.specimens.push(JSON.parse(JSON.stringify(newSpecimen())))
    },
    select(payload: { value: any, key: string, idx: number }) {
      if ((this.$store.getters.formState === 'editingUnsaved') || (this.$store.getters.formState === 'editing' && this.added)) {
        // edit nested structure of config if specimen is deleted and newly added
        this.specimens[payload.idx].find((sp: LichenRecordField) => sp.name === payload.key).value = payload.value
      } else if (this.$store.getters.formState === 'editing' && !this.added) {
        // edit flat structure
        this.specimens[payload.idx][payload.key] = payload.value
      }
    },
  },
  watch: {
    specimens: {
      handler() {
        this.$emit('select', { key: this.name, value: this.specimens })
      },
      deep: true
    }

  },
  beforeMount() {
    // @ts-ignore
    this.specimens = this.value

  }
})
